import { BookOpenIcon } from "@heroicons/react/24/outline";
import { SidebarMode } from "components/layout/sidebar";
import { docsBaseUrl } from "constants/branding";
import React from "react";
import { NgSidebarItem } from "./ng-sidebar-item";
import { WhiteLabelRestricted } from "./white-label-restricted";

interface DocLinkProps {
    path: string;
    children: React.ReactNode;
    className?: string;
}

export const DocLink: React.FC<DocLinkProps> = ({ path, children, className }) => {
    return (
        <WhiteLabelRestricted>
            <a
                href={`${docsBaseUrl}${path}`}
                target="_blank"
                rel="noreferrer"
                className={className}>
                {children}
            </a>
        </WhiteLabelRestricted>
    );
};

export const DocLinkSidebarItem: React.FC<{ mode: SidebarMode }> = ({ mode }) => {
    return (
        <WhiteLabelRestricted>
            <NgSidebarItem
                href={docsBaseUrl}
                current={false}
                icon={BookOpenIcon}
                label="Tutorials"
                mode={mode}
            />
        </WhiteLabelRestricted>
    );
};
